import request from 'utils/request'

export function registration(data) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}
